import { render, staticRenderFns } from "./list-of-members.vue?vue&type=template&id=80033a6c&scoped=true&"
import script from "./list-of-members.vue?vue&type=script&lang=js&"
export * from "./list-of-members.vue?vue&type=script&lang=js&"
import style0 from "./list-of-members.vue?vue&type=style&index=0&id=80033a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80033a6c",
  null
  
)

component.options.__file = "list-of-members.vue"
export default component.exports